// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2p50b","loginContent":"Login_loginContent__2mEE_","signingIn":"Login_signingIn__vSRNU","termsText":"Login_termsText__2FT6G","links":"Login_links__3T5kO"};